export const EVENTS = {
	IdeaFieldUpdated: 'idea_field_updated',
} as const;
